import ReactLoading from 'react-loading';

const Loading = (props) => (
    <ReactLoading {...props}/>
);
export default Loading;